import { Component, Input, OnInit } from '@angular/core';
import { IPlantToDepotTour } from 'src/app/interfaces/ITour';

@Component({
  selector: 'tour-list-item',
  templateUrl: './tour-list-item.component.html',
  styleUrls: ['./tour-list-item.component.css']
})
export class TourListItemComponent {
  @Input() url: string;
  @Input() tour: IPlantToDepotTour;

  @Input("show-driver") showDriver = false 
}
